import React, { Component } from 'react';


export class Label extends Component {

  constructor(props){
    super(props);
    this.state = {text_extents:null};
  }

  componentDidMount() {
   const box = this.text.getBBox();
   this.setState({text_extents:[box.width,box.height]});
  }

  render() {
   const margin = 4;
   const extents = this.state.text_extents;
   const label = <text ref={(t) => { this.text = t; }} textAnchor="middle" dy={extents?(extents[1]/4):0} >{this.props.children}</text>;
   const outline = extents ?
         <rect
          x={-this.props.width/2 || -extents[0]/2-margin}
          y={-extents[1]/2-margin}
          width={this.props.width || extents[0]+2*margin}
          height={extents[1]+1.5*margin}
          fill={this.props.backgroundColor}
          className="labeloutline"></rect>
         : null;

   return <g
      transform={`translate(${this.props.x},${this.props.y})
        rotate(${this.props.angle})
        scale(${this.props.scale},${this.props.scale})`}>
      {outline}{label}
    </g>;
 }
}
